/**
 * Waffle switches should be added to this list before usage in JS/TS.
 * Each entry should:
 *   - Be given a descriptive key name
 *   - Include a description of what the switch gates
 *   - Link to a ticket for switch removal, or an explanation as to why there isn't one
 *
 * Note: Though this enum can (and should!) be used from JS/Ractive, its usage is only
 * _enforced_ in TS code, so it's still recommended to search for both the enum AND the
 * "raw" waffle switch string for removal, unless you are sure you know otherwise.
 */
enum WaffleSwitch {
  // Internal-only switch for use in unit tests.
  TestSwitch = 'test-switch',

  // WPLAT switches
  // -----------
  Onboarding = 'onboarding',
  // Enables the new axp ecomm flow (removal: WPLAT-770)
  AxpEcommV1 = 'axp-ecomm-v1',

  // ^^^ Add new switches to your team's section ^^^
  // Be sure to add new switches to airship/polybius/switches.py, otherwise they
  // will not be created by the sync_switches management command!
}

export default WaffleSwitch
